<template>
  <div class="checklist-item">
    <div class="check-header" v-if="title">
      <div class="check-title">
        {{ title }}
        <p class="status" :class="complete ? 'complete' : 'incomplete'">
          {{ complete ? "Complete!" : "Items Needed" }}
        </p>
      </div>
    </div>
    <div class="check-content">
      <slot></slot>
    </div>
</div>
</template>
<script setup lang="ts">
import { defineProps, withDefaults } from "vue";

interface Props {
  title: any;
  complete?: boolean;
}

const props = withDefaults(defineProps<Props>(), {});

</script>
<style lang="scss" scoped>
.checklist-item {
  border: 1px solid lightgray;
  padding: 1em;
  margin-bottom: 1em;
  background-color: #eeeeee;
}
.check-header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .check {
      height: 30px;
      width: 30px;
      border: 1px solid black;
      margin-right: 10px;
      text-align: center;
      font-size: 3em;
      color: green;
    }

    .check-title {
      font-weight: 700;
      font-size: 1.25rem;
      display: flex;
      line-height: 30px;

      .status {
        color: #bb0000;
        margin: 0 10px;
        &.normal {
          color: black;
        }

        &.incomplete {
          color: #bb0000;
        }
        &.complete {
          color: green;
        }
      }
    }

    .toggle {
      all: unset;
      font-size: 3rem;
      font-weight: 700;
      line-height: 40px;
      cursor: pointer;
    }
  }
</style>